import { Component, OnInit }            from '@angular/core';
import { Router }                       from '@angular/router';
import { UserService }                  from '../../_services/user.service'; 
import { RecaptchaModule , RecaptchaFormsModule}              from 'ng-recaptcha';
//import { RecaptchaFormsModule }         from 'ng-recaptcha/forms';
import { EqualValidator }               from '../../_directives/index';
//import { IMG_ANI_REFRESH}               from '../../_models/constants';
//import { UsePiwikTracker } from 'Angular2Piwik';
import { first }          from 'rxjs/operators';
import { Subscription } from 'rxjs';

export interface FormModel {
  captcha?: string;
}
declare var $: any;

@Component({
  selector: 'ind-register',
  //providers: [UsePiwikTracker],    
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})

export class RegisterComponent implements OnInit {

    model: any = {};
    formModel: FormModel = {};
    loading:boolean = false;
    success:boolean = false;
    failure:boolean = false;
    alreadyregistered: boolean = false;
    doc: any;
    subscription: Subscription | null = null;
    constructor(
        private router: Router,
        private userService: UserService,
        ) {
        //    usePiwikTracker.trackPageView();
         }

    ngOnInit() {
        //this.IMG_ANI_REFRESH = IMG_ANI_REFRESH;  
    }

    ngOnDestroy() {
        $('#addedThis').remove();
        $('.addthis-smartlayers').remove();  
        try{
            this.subscription?.unsubscribe();  
        }catch(e){

        }        
    }

    register(value: any, valid: boolean) {//alert('here'+JSON.stringify(this.model))
        this.loading = true; //console.log('Model-'+JSON.stringify(this.model));
        this.model.email = this.model.email ? this.model.email.toLowerCase().trim() : '';
        this.subscription = this.userService.create(this.model)
            .pipe(first())
            .subscribe(
                (data:any) => {console.log('Registration is successful: Data.ok '+JSON.stringify(data));
                    this.loading = false;//this.model = {};       
                    this.failure = (data.ok !== undefined && data.ok == false) ? true : false;              
                    this.alreadyregistered = (this.failure && data.message == 'email already exists') ? true : false;
                    //if (data.ok === false && data.message == 'email already exists'){
                    if (this.failure){//console.log('Success is false')
                        /*if (data.message == 'email already exists'){
                            this.alreadyregistered = true;
                        }else{
                            this.failure = true;
                        } */                       
                        this.success = false; 
                    }else{
                        this.success = true; 
                        /*$('#addedThis').remove();
                        $('.addthis-smartlayers').remove();
                        var s = document.createElement("script");
                        s.id = "addedThis";
                        s.type = "text/javascript";
                        s.src = "//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a14efa6efc2db8a";
                        $("body").append(s);                                    */
                    }
                },
                err => {
                    console.log("Error: "+JSON.stringify(err))
                    this.failure = true; this.success = false; 
                    this.loading = false;
                });
              
    }

    refresh(){
        window.location.reload();
    }
}



